var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5381_31977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4.5H3.33333H14",
    stroke: "#51565B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14286 4.5V2.9C5.14286 2.5287 5.29337 2.1726 5.56128 1.91005C5.82919 1.6475 6.19255 1.5 6.57143 1.5H9.42857C9.80745 1.5 10.1708 1.6475 10.4387 1.91005C10.7066 2.1726 10.8571 2.5287 10.8571 2.9V4.5M13 4.5V14.1C13 14.4713 12.8495 14.8274 12.5816 15.0899C12.3137 15.3525 11.9503 15.5 11.5714 15.5H4.42857C4.04969 15.5 3.68633 15.3525 3.41842 15.0899C3.15051 14.8274 3 14.4713 3 14.1V4.5H13Z",
    stroke: "#51565B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5381_31977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBox);
export default __webpack_public_path__ + "static/media/TrashBox.a7a1845b9aa16224a79496c2e7312846.svg";
export { ForwardRef as ReactComponent };